/**
 * Back-in-stock handoff for the Quick View dialog.
 *
 * Klaviyo's native back-in-stock button only injects on product pages, so an
 * out-of-stock variant selected inside the quick-add dialog dead-ends on a
 * disabled "Sold out" button. When that happens, this swaps in a "Notify Me"
 * link to the product page with the variant preselected (plus a #notify hash),
 * where Klaviyo's own capture takes over. On product pages, the #notify hash
 * auto-opens the injected Klaviyo back-in-stock modal.
 */
(function () {
  var LINK_CLASS = 'quick-add-notify-me-link';

  function productUrlFrom(content, form) {
    // The title link is re-rendered on every color/product morph inside the
    // dialog; data-product-url on product-form-component can go stale after a
    // combined-listing color swap, so it is only the fallback.
    var titleLink = content.querySelector('.view-product-title a');
    var url = (titleLink && titleLink.getAttribute('href')) || form.getAttribute('data-product-url');
    if (!url) return null;
    return url.split('#')[0].split('?')[0];
  }

  function syncDialog() {
    var content = document.getElementById('quick-add-modal-content');
    if (!content) return;
    var form = content.querySelector('product-form-component form');
    if (!form) return;
    var addButton = form.querySelector('button[type="submit"][name="add"], button.add-to-cart-button[type="submit"]');
    var existing = form.querySelector('a.' + LINK_CLASS);
    var unavailable = !!(addButton && addButton.disabled);

    if (!unavailable) {
      if (existing) existing.remove();
      if (addButton && addButton.style.display === 'none') addButton.style.removeProperty('display');
      return;
    }

    var component = content.querySelector('product-form-component');
    var baseUrl = productUrlFrom(content, component || form);
    if (!baseUrl) return;
    var variantInput = form.querySelector('input[name="id"]');
    var href = baseUrl + (variantInput && variantInput.value ? '?variant=' + variantInput.value : '') + '#notify';

    if (existing) {
      if (existing.getAttribute('href') !== href) existing.setAttribute('href', href);
      return;
    }

    var link = document.createElement('a');
    link.className = 'button add-to-cart-button ' + LINK_CLASS;
    link.setAttribute('href', href);
    link.style.cssText = 'width:100%;display:flex;align-items:center;justify-content:center;text-decoration:none;';
    link.textContent = addButton.getAttribute('data-notify-me-label') || 'Notify Me';
    if (addButton.style.display !== 'none') addButton.style.display = 'none';
    addButton.insertAdjacentElement('afterend', link);
  }

  function watchDialog() {
    var content = document.getElementById('quick-add-modal-content');
    if (!content) return;
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        syncDialog();
      });
    });
    observer.observe(content, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value'] });
  }

  function autoOpenBackInStock() {
    if (window.location.hash !== '#notify') return;
    var tries = 0;
    var timer = setInterval(function () {
      var bisButton = document.querySelector('#klaviyo-bis-button-container button');
      if (bisButton) {
        clearInterval(timer);
        bisButton.click();
        history.replaceState(null, '', window.location.pathname + window.location.search);
      } else if (++tries > 40) {
        clearInterval(timer);
      }
    }, 250);
  }

  function init() {
    watchDialog();
    autoOpenBackInStock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
